import { backendUrl } from '../constants/urls';
import clientApi from '../constants/urls';

const retrieveBusiness = () => {
	return clientApi.get(`${backendUrl}/business`);
};

const businessService = { retrieveBusiness };

export default businessService;
